import type { WithUnknownProperties } from '@schibsted-nmp/advertising-shared';

import { Resolver } from './Resolver.js';
import type { Interface } from './Interface/index.js';
import type * as _Window from './Window.js';

export const Api = new Resolver().proxy;

export type Api = Api.Uninitialized | Api.Initialized | Api.Loaded;

export namespace Api {
  export type Uninitialized = { cmd?: Array<VoidFunction> } | undefined;
  export type Initialized = Readonly<Required<NonNullable<Api.Uninitialized>>>;
  export type Loaded = WithUnknownProperties<Initialized & Interface>;
}

export * from './Interface/index.js';
export * as Common from './Common/index.js';
export * from './Window.js';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/consistent-type-definitions
  interface Window extends _Window.Window {}
}
